/**
 * @fileoverview Layout constants for consistent UI structure across the app.
 */

export const HEADER_HEIGHT = 56;
export const PROGRESS_SECTION_HEIGHT = 200;
export const HORIZONTAL_TABS_HEIGHT = 56;
// Mobile progress section: ProgressCard (44px) — flush, no extra padding
export const MOBILE_PROGRESS_HEIGHT = 44;
export const MOBILE_TABBAR_HEIGHT = 56;
export const CHAT_INPUT_HEIGHT = 72;
export const FAB_SIZE = 56;
export const FAB_CHAT_GAP = 12;

/**
 * Z-Index Scale (higher = on top)
 */
export const Z_INDEX = {
  background: 0,
  content: 1,
  stickyHeader: 100,

  // Fixed Global UI (900-1100)
  progressSection: 900,
  globalHeader: 1000,
  tabbar: 1100,
  sidebar: 1150,

  // Interactive Overlays (1500-3000)
  dropdown: 1500,
  offlineIndicator: 2000,
  chatOverlay: 2100,
  chatInputBar: 2200,
  fab: 2500,
  modal: 3000,
  tooltip: 3100,
  splash: 9000,
  max: 9999,
};

export const CSS_VARS = {
  safeTop: '--tg-safe-top',
  safeBottom: '--tg-safe-bottom',
  headerHeight: '--tg-header-h',
  progressHeight: '--tg-progress-h',
  tabbarHeight: '--tg-tabbar-h',
  chatInputHeight: '--tg-chat-h',
  chatOverlayHeight: '--tg-chat-overlay-h',
  contentLeftPad: '--tg-content-left-pad',
  visualViewportTop: '--tg-vv-top',
  contentTop: '--tg-content-top',
};

/**
 * Calculate top content offset based on UI elements
 */
export const getContentTop = (hasProgress = true) => {
  const header = HEADER_HEIGHT;
  const progress = hasProgress ? MOBILE_PROGRESS_HEIGHT : 0;
  return header + progress;
};

/**
 * Calculate bottom content offset based on UI elements
 */
export const getContentBottom = (hasChat = true, hasTabbar = true) => {
  const chat = hasChat ? CHAT_INPUT_HEIGHT : 0;
  const tabbar = hasTabbar ? MOBILE_TABBAR_HEIGHT : 0;
  return chat + tabbar;
};

export default {
  HEADER_HEIGHT,
  PROGRESS_SECTION_HEIGHT,
  MOBILE_PROGRESS_HEIGHT,
  MOBILE_TABBAR_HEIGHT,
  CHAT_INPUT_HEIGHT,
  FAB_SIZE,
  FAB_CHAT_GAP,
  Z_INDEX,
  CSS_VARS,
  getContentTop,
  getContentBottom,
};
